import React from "react";
import PropTypes from "prop-types";
import translate from "react-i18next/dist/commonjs/translate";

const IncidentsWidgetSummary = ({ incidentSummary, t }) => {
  return (
    <div className="row legend-row">
      <div className="legend-column-wrapper">
        <div className="legend-item threatcon1-red">
          <h3>{t("incidentWidgetSummaryPriority1")}</h3>
          <p>{incidentSummary.Priority1Count}</p>
        </div>
        <div className="legend-item threatcon2-orange">
          <h3>{t("incidentWidgetSummaryPriority2")}</h3>
          <p>{incidentSummary.Priority2Count}</p>
        </div>
        <div className={`legend-item threatcon3-yellow`}>
          <h3>{t("incidentWidgetSummaryPriority3")}</h3>
          <p>{incidentSummary.Priority3Count}</p>
        </div>
        <div className={`legend-item threatcon4-green `}>
          <h3>{t("incidentWidgetSummaryPriority4")}</h3>
          <p>{incidentSummary.Priority4Count}</p>
        </div>
      </div>
    </div>
  );
};

IncidentsWidgetSummary.propTypes = {
  incidentSummary: PropTypes.object.isRequired
};

export default translate("translations")(IncidentsWidgetSummary);



// WEBPACK FOOTER //
// ./src/dashboard/widgets/IncidentsWidgetSummary.js